// React
import { useEffect, useState } from "react";

// MUI
import Typography from "@mui/material/Typography";

type NumericProgressProps = {
	value: number;
	interval: number;
};
export default function NumericProgress(props: Readonly<NumericProgressProps>) {
	const [progress, setProgress] = useState(60);

	if (progress === 0) {
		setProgress(60);
	}

	useEffect(() => {
		const timer = setInterval(() => {
			setProgress((prevProgress) => prevProgress - 1);
		}, 1000);
		return () => {
			clearInterval(timer);
		};
	}, [props.interval]);

	return <Typography sx={{ fontFamily: "PT Sans Narrow", color: "white" }}>{`${Math.round(progress)}`}</Typography>;
}
